import { FlowTemplate, Transition, SideEffect } from "../../../../../common/models/flow.dto";
import { InjectionToken } from "@angular/core";

export const SIDE_EFFECT_DATA_TOKEN: InjectionToken<SideEffectData>
    = new InjectionToken('SIDE_EFFECT_DATA');
export type SideEffectData = { transition: Transition, sideEffect: SideEffect, configuration: any, template: FlowTemplate };